var map = {
	"./anhui": "a64f",
	"./anhui.json": "a64f",
	"./aomen": "1513",
	"./aomen.json": "1513",
	"./beijing": "c5e9",
	"./beijing.json": "c5e9",
	"./chongqing": "f199",
	"./chongqing.json": "f199",
	"./fujian": "233f",
	"./fujian.json": "233f",
	"./gansu": "a716",
	"./gansu.json": "a716",
	"./guangdong": "5fd6",
	"./guangdong.json": "5fd6",
	"./guangxi": "74ac",
	"./guangxi.json": "74ac",
	"./guizhou": "bda1",
	"./guizhou.json": "bda1",
	"./hainan": "cb2c",
	"./hainan.json": "cb2c",
	"./hebei": "ea78",
	"./hebei.json": "ea78",
	"./heilongjiang": "18c4",
	"./heilongjiang.json": "18c4",
	"./henan": "a29f",
	"./henan.json": "a29f",
	"./hubei": "a16a",
	"./hubei.json": "a16a",
	"./hunan": "9798",
	"./hunan.json": "9798",
	"./jiangsu": "07f6",
	"./jiangsu.json": "07f6",
	"./jiangxi": "2050",
	"./jiangxi.json": "2050",
	"./jilin": "7b84",
	"./jilin.json": "7b84",
	"./liaoning": "d8b9",
	"./liaoning.json": "d8b9",
	"./neimenggu": "7cdf",
	"./neimenggu.json": "7cdf",
	"./ningxia": "50f6",
	"./ningxia.json": "50f6",
	"./qinghai": "187c",
	"./qinghai.json": "187c",
	"./shandong": "e2bc",
	"./shandong.json": "e2bc",
	"./shanghai": "3030",
	"./shanghai.json": "3030",
	"./shanxi": "8bdf",
	"./shanxi.json": "8bdf",
	"./shanxi1": "f92e",
	"./shanxi1.json": "f92e",
	"./sichuan": "2b63",
	"./sichuan.json": "2b63",
	"./taiwan": "7ea9",
	"./taiwan.json": "7ea9",
	"./tianjin": "46cc",
	"./tianjin.json": "46cc",
	"./xianggang": "5d41",
	"./xianggang.json": "5d41",
	"./xinjiang": "b71d",
	"./xinjiang.json": "b71d",
	"./xizang": "54f0",
	"./xizang.json": "54f0",
	"./yunnan": "1bc1",
	"./yunnan.json": "1bc1",
	"./zhejiang": "f1ef",
	"./zhejiang.json": "f1ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4e23";